import { createContext, useContext } from 'react';

import type { FormInstance } from 'antd';

import type { Option, RoomTypeGroupOption } from '../types';

type CMASummaryRoomTypeFilterFormValues = {
  roomTypes: number[];
  groupingValue: number;
  comparisonType: number;
  comparisonSqftRange: number;
  showClosestBeyondRange: boolean;
  roomTypesPriceDisplay: number;
};

type CMASummaryRoomTypeFilterContextValue = {
  form: FormInstance<CMASummaryRoomTypeFilterFormValues>;
  options: Option[];
  groupedOptions: RoomTypeGroupOption[];
};

export const CMASummaryRoomTypeFilterContext = createContext<CMASummaryRoomTypeFilterContextValue | null>(null);

export const useCMASummaryRoomTypeFilterContext = () => {
  const context = useContext(CMASummaryRoomTypeFilterContext);

  if (!context) {
    throw new Error('CMASummaryRoomTypeFilterContext must be used within a provider.');
  }

  return context;
};

export type { CMASummaryRoomTypeFilterFormValues };
